import api from '@/services/api';

const SEND_CODE_CANDIDATES = [
  {
    method: 'POST',
    path: '/auth/activation/send-code',
    buildBody: () => ({}),
    canFallbackOnValidation: false,
  },
  {
    method: 'POST',
    path: '/auth/send-activation-code',
    buildBody: () => ({}),
    canFallbackOnValidation: false,
  },
  {
    method: 'POST',
    path: '/auth/send-code',
    buildBody: ({ email }) => ({ email, purpose: 'activation' }),
    canFallbackOnValidation: true,
  },
  {
    method: 'POST',
    path: '/auth/send-code',
    buildBody: ({ email }) => ({ email }),
    canFallbackOnValidation: true,
  },
];

const VERIFY_CODE_CANDIDATES = [
  {
    method: 'POST',
    path: '/auth/activation/verify-code',
    buildBody: ({ code }) => ({ code }),
    canFallbackOnValidation: false,
  },
  {
    method: 'POST',
    path: '/auth/verify-activation-code',
    buildBody: ({ code }) => ({ code }),
    canFallbackOnValidation: false,
  },
  {
    method: 'POST',
    path: '/auth/verify-code',
    buildBody: ({ code }) => ({ code }),
    canFallbackOnValidation: true,
  },
  {
    method: 'POST',
    path: '/auth/verify-code',
    buildBody: ({ code, email }) => ({ code, email }),
    canFallbackOnValidation: true,
  },
];

function shouldTryNextCandidate(error, canFallbackOnValidation) {
  const status = error?.response?.status;

  if (status === 404 || status === 405) {
    return true;
  }

  if (canFallbackOnValidation && (status === 400 || status === 422)) {
    return true;
  }

  return false;
}

async function runCandidateRequest(candidates, context) {
  let lastError = null;

  for (const candidate of candidates) {
    try {
      const payload = candidate.buildBody(context);
      const response = await api({
        method: candidate.method,
        url: candidate.path,
        data: payload,
      });

      return {
        response,
        endpoint: {
          method: candidate.method,
          path: candidate.path,
        },
      };
    } catch (error) {
      lastError = error;
      if (shouldTryNextCandidate(error, candidate.canFallbackOnValidation)) {
        continue;
      }
      throw error;
    }
  }

  throw lastError || new Error('Nenhum endpoint de ativação respondeu com sucesso.');
}

export const accountActivationService = {
  async resendCode({ email }) {
    return runCandidateRequest(SEND_CODE_CANDIDATES, { email });
  },

  async verifyCode({ code, email }) {
    return runCandidateRequest(VERIFY_CODE_CANDIDATES, { code, email });
  },
};
